export var EditorMode;
(function (EditorMode) {
    EditorMode["REGULAR"] = "regular";
    EditorMode["ASSISTANT"] = "assistant";
})(EditorMode || (EditorMode = {}));
export var FileStatus;
(function (FileStatus) {
    FileStatus["Uploading"] = "uploading";
    FileStatus["Uploaded"] = "uploaded";
})(FileStatus || (FileStatus = {}));
//# sourceMappingURL=index.js.map